import { render, staticRenderFns } from "./DeviceDetailsG2Speaker.vue?vue&type=template&id=0400dd71&scoped=true&"
import script from "./DeviceDetailsG2Speaker.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsG2Speaker.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailsG2Speaker.vue?vue&type=style&index=0&id=0400dd71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0400dd71",
  null
  
)

export default component.exports